"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const customElement_1 = tslib_1.__importDefault(require("../../lib/customElement"));
class PageHeader extends customElement_1.default {
    constructor() {
        super(...arguments);
        this.STYLE = `
        <style>
            header {
                border-bottom: black solid 1px;
                display: flex;
                justify-content: space-around;
            }
            
            #branding {
                width: 40%;
            }
            
            #nav {
                width: 50%;
            }
            
            ul {
                list-style: none;
                display: flex;
                justify-content: space-around;
            }
            
            ul li a {
                text-decoration: none;
                color: black;
            } 
            
            ul li a:visited {
                text-decoration: none;
                color: black;
            } 
            
            @media (max-width: 500px) {
                header {
                    flex-direction: column;
                }
                #nav, #branding {
                    width: 95%;
                }
            }
        </style>
    `;
        this.TEMPLATE = `
        <header>
            <section id="branding">
                <h1>Reframing Hate</h1>
            </section>
            <section id="nav">
                <ul>
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                    <li><a href="#getInvolved">Get Involved</a></li>
                    <li><a href="#faq">FAQ</a></li>
                </ul>
            </section>
        </header>
    `;
    }
}
exports.default = PageHeader;
//# sourceMappingURL=data:application/json;base64,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